import React from 'react';
import { Route, Switch } from 'react-router';
import Layout from 'components/Layout';
import List from './List';
import Form from './Form';

const Client = () => (
  <Layout>
    <Switch>
      <Route exact path="/clients" component={List} />
      <Route exact path="/clients/new" component={Form} />
      <Route exact path="/clients/:id" component={Form} />
    </Switch>
  </Layout>
);

export default Client;
